import { Injectable, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {PopulationCategoryApi } from '../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../theme/services/baToastNotification';

@Component({
  selector: 'app-population-group',
  templateUrl: './population-group.component.html',
  styleUrls: ['./population-group.component.scss'],
  providers:[PopulationCategoryApi,BaToastNotificationService]
})

@Injectable()
export class PopulationGroupComponent implements OnInit {

  private populationGroupSource = new BehaviorSubject<object>({})
  population_group = this.populationGroupSource.asObservable();

  private populationGroupsSource = new BehaviorSubject<object>([])
  population_groups = this.populationGroupsSource.asObservable();

  private totalItemsSource = new BehaviorSubject<number>(0)
  total_items = this.totalItemsSource.asObservable();

  private pSource = new BehaviorSubject<number>(1) // first page
  p = this.pSource.asObservable();

  private itemsPerPageSource = new BehaviorSubject<number>(10)
  itemsPerPage = this.itemsPerPageSource.asObservable();// number of items per page

  private searchingSource = new BehaviorSubject<boolean>(false)
  searching = this.searchingSource.asObservable();

  private editedIdSource = new BehaviorSubject<number>(null)
  editedId = this.editedIdSource.asObservable();

  constructor(protected populationCategoryService:PopulationCategoryApi,private toast: BaToastNotificationService) { }

  ngOnInit() {
    this.getPopulationGroups(this.pSource.getValue());
    this.getCount();
  }

  refresh(){
    this.pSource.next(1);
    this.getPopulationGroups(this.pSource.getValue());
    this.editedIdSource.next(null);
    this.getCount();
  }

  getPopulationGroups(page: number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.populationCategoryService.find({
      order: "id DESC",
      include: ['sector'],
      limit: this.itemsPerPageSource.getValue(),
      skip: skip
    })
        .subscribe((res) => {
              this.populationGroupsSource.next(res);
            },
            ((error) => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            }))
  }

  getCount(){
    this.populationCategoryService.count().subscribe((res) => {
      if(res)
        this.totalItemsSource.next(res.count);
    })
  }

  search(term: string, page:number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.populationCategoryService.search(term, this.itemsPerPageSource.getValue(), skip)
        .subscribe( results => {
              this.totalItemsSource.next(results.data.total);
              this.populationGroupsSource.next(results.data.population_categories);
              this.searchingSource.next(false);
            },
            err => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            })
  }

  updatePopulationGroupSource(data){
    this.populationGroupSource.next(data);
    this.editedIdSource.next(data.id);
  }

  cancelSelected(){
    this.editedIdSource.next(null);
    this.populationGroupSource.next({});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/population-group/population-group.component.ts